import { render, staticRenderFns } from "./DesignContainer.vue?vue&type=template&id=56c8059b&scoped=true&"
import script from "./DesignContainer.vue?vue&type=script&lang=js&"
export * from "./DesignContainer.vue?vue&type=script&lang=js&"
import style0 from "./DesignContainer.vue?vue&type=style&index=0&id=56c8059b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8059b",
  null
  
)

export default component.exports